import request from '../utils/request';
import { buildApiPayload } from '../utils/api';
import baseApi from './baseApi';

export function getBreadingEvents(params, signal) {
  return request({
    url: '/breadingTimerCycleHistory',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getBreadingTotal(params, signal) {
  return request({
    url: '/breadingTimerCycleHistory/total',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    signal,
  });
}

export function getExelExport(params) {
  return request({
    url: '/breadingTimerCycleHistory/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}

export function deleteBreading(uuid) {
  return request({
    url: `/breadingTimerCycleHistory/${uuid}`,
    method: 'delete',
  });
}

const breadingApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    bulkDeleteBreadingTCHs: builder.mutation({
      query: ({ uuids }) => ({
        url: '/breadingTimerCycleHistory',
        method: 'DELETE',
        data: {
          uuids,
        },
      }),
    }),
  }),
});

export const {
  useBulkDeleteBreadingTCHsMutation: useBulkDeleteBreadingTCHs,
} = breadingApi;

export default breadingApi;
